module.exports = __webpack_public_path__ + "h5/img/right.bfc868a6.png";